<template>
  <div>
    <slot name="default"></slot>
    <BaseDialog
      :title="dialogTitle"
      :isOpen="dialogOpen"
      @cancel="$emit('closeDialog')"
      @close="$emit('closeDialog')"
      :hideFooter="hideDialogFooter"
    >
      <slot name="dialog"></slot>
    </BaseDialog>
  </div>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog.vue'

export default {
  props: {
    dialogOpen: Boolean,
    dialogTitle: String,
    hideDialogFooter: Boolean
  },
  components: {
    BaseDialog
  },

  data() {
    return {
      showFilterDialog: false
    }
  },
  methods: {}
}
</script>
